module.exports = __webpack_public_path__ + "static/how_wide_illu-99e2bcc0151725b3a4105b30668a0aba.svg";